<template>
  <a class="cbx" :class="{checked}" @click="$emit('change', !checked)">
    <div class="cbx-content">
      <font-awesome-icon :icon="['fas', 'check']"/>
    </div>
    <slot/>
  </a>
</template>

<script>
export default {
  name: 'CheckBox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean,
    label: String
  }
}
</script>

<style scoped lang="scss">
  .cbx {
    $cbx-size: 22px !default;
    $cbx-border-color: #dce3f1 !default;
    $cbx-background-color: $cbx-border-color !default;
    $cbx-active-background-color: #5da6ec !default;
    $cbx-active-border-color: $cbx-active-background-color !default;
    $cbx-icon-color: darken($cbx-background-color, 10) !default;
    $cbx-icon-active-color: white !default;
    $cbx-border-radius: 5px !default;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 13px;
    margin: 0;

    .cbx-content {
      margin-right: 10px;
      box-sizing: border-box;
      height: $cbx-size;
      width: $cbx-size;
      border: 1px solid $cbx-border-color;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: $cbx-background-color;
      color: $cbx-icon-color;
      border-radius: 5px;
      transition: 100ms linear all;
    }

    &.checked .cbx-content {
      border-color: $cbx-active-border-color;
      background-color: $cbx-active-background-color;
      color: $cbx-icon-active-color;
    }
  }
</style>
